exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".src-components-testDetails-NotesCard-container{white-space:pre-wrap}.src-components-testDetails-NotesCard-empty{color:#929292}.src-components-testDetails-NotesCard-noteArea{border:3px solid #b3b3b3 !important;border-radius:0 !important;background-color:#fcfcfc !important}", ""]);

// exports
exports.locals = {
	"container": "src-components-testDetails-NotesCard-container",
	"empty": "src-components-testDetails-NotesCard-empty",
	"noteArea": "src-components-testDetails-NotesCard-noteArea"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1,"modules":true,"localIdentName":"[path][local]"}!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./node_modules/sass-loader/dist/cjs.js!./src/components/testDetails/NotesCard/styles.scss
// module id = ./node_modules/css-loader/index.js?{"importLoaders":1,"modules":true,"localIdentName":"[path][local]"}!./node_modules/postcss-loader/lib/index.js?{"ident":"postcss","plugins":[null,null]}!./node_modules/sass-loader/dist/cjs.js!./src/components/testDetails/NotesCard/styles.scss
// module chunks = 1